import Journal from '../sections/journal/journal';

export default function JournalPage() {
  return (
    <div className="section-page">
      <Journal />
    </div>
  );
}
